var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import { Tab, Button, Stack } from "@bookingcom/bui-react";
import classNames from "../../utilities/classNames";
import "./Header.types";
import styles from "./Header.module.css";
import TabList from "./TabList";
var renderAction = function (action, index, actions) {
    var key = "action_".concat(index);
    if (index < actions.length - 1) {
        return action;
    }
    return (React.createElement(Button.Aligner, { alignment: "end", key: key }, action));
};
var Header = function (props) {
    var actions = props.actions, activeTabId = props.activeTabId, className = props.className, defaultActiveTabId = props.defaultActiveTabId, logo = props.logo, onTabChange = props.onTabChange, tabs = props.tabs, tabsMoreLabel = props.tabsMoreLabel, tabsIntroLabel = props.tabsIntroLabel, _a = props.variant, variant = _a === void 0 ? "default" : _a;
    var rootClassNames = classNames(styles.root, className, variant === "transparent-light" && styles["root--variant-transparent-light"]);
    var restTabsProps = activeTabId
        ? { activeTabId: activeTabId, "aria-selected": true }
        : { defaultActiveTabId: defaultActiveTabId };
    var tabsAttributes = useMemo(function () {
        var _a;
        return ({
            "data-testid": "header-xpb",
            "aria-label": tabsIntroLabel,
            "aria-owns": (_a = tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab) { return tab.id; })) === null || _a === void 0 ? void 0 : _a.join(" "),
        });
    }, [tabsIntroLabel, tabs]);
    return (React.createElement("header", { className: rootClassNames },
        React.createElement("nav", { className: styles.bar },
            React.createElement("div", { className: styles.main },
                React.createElement("div", { className: styles.logo }, logo)),
            React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "end", gap: 2 }, actions && actions.map(renderAction))),
        tabs && !!tabs.length && (React.createElement(Tab, __assign({ color: "inherit", className: styles.tab, onTabChange: onTabChange, moreLabel: tabsMoreLabel, variant: "rounded", attributes: tabsAttributes }, restTabsProps),
            React.createElement(TabList, { tabs: tabs })))));
};
export default Header;
